import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountClientUpdatePage = lazy(() => import('../views/update/AccountClientUpdatePage'));

export function AccountClientUpdatePageLazy() {
	return (
		<PageSuspense>
			<AccountClientUpdatePage />
		</PageSuspense>
	);
}
